export const informationTabs = [
    { label: "Personal Details", value: "details" },
    // { label: "Family", value: "family" },
  ];